import GetInvoiceLabels from "../../../utils/getInvoiceLabels";
import PersonalInformation from "./PersonalInformation";
import GuardianInformation from "./GuardianInformation";
import Address from "./Address";
import ContactInformation from "./ContactInformation";
import ExamReason from "./ExamReason";
import SpecialRequirements from "./SpecialRequirements";
import ThirdPartyInvoice from "./ThirdPartyInvoice";
import InvoiceDetails from "./InvoiceDetails";

const CandidateSummary = ({
  pageText,
  candidateDetails,
  examDetails,
  lookupData,
  examRulesData,
  showGuardianFields,
}: {
  pageText: any;
  candidateDetails: any;
  examDetails: any;
  lookupData: any;
  examRulesData: any;
  showGuardianFields: boolean;
}) => {
  const invoiceTypes = GetInvoiceLabels();

  return (
    <>
      <PersonalInformation
        pageText={pageText}
        candidateDetails={candidateDetails}
        lookupData={lookupData}
      />

      {showGuardianFields && (
        <GuardianInformation
          pageText={pageText}
          candidateDetails={candidateDetails}
        />
      )}

      <Address pageText={pageText} candidateDetails={candidateDetails} />

      <ContactInformation
        pageText={pageText}
        candidateDetails={candidateDetails}
        showGuardianFields={showGuardianFields}
      />

      <ExamReason
        pageText={pageText}
        candidateDetails={candidateDetails}
        lookupData={lookupData}
        examDetails={examDetails}
      />

      {candidateDetails?.specialRequestType.label && (
        <SpecialRequirements
          pageText={pageText}
          candidateDetails={candidateDetails}
          lookupData={lookupData}
        />
      )}

      {examRulesData?.examRegistrationRules?.isThirdPartyInvoiceEnabled && (
        <ThirdPartyInvoice
          pageText={pageText}
          candidateDetails={candidateDetails}
        />
      )}

      {examRulesData?.examRegistrationRules?.isEIIIntegrationEnabled && (
        <InvoiceDetails
          pageText={pageText}
          candidateDetails={candidateDetails}
          invoiceTypes={invoiceTypes}
        />
      )}
    </>
  );
};

export default CandidateSummary;
